var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStarBlueFilled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 22,
    viewBox: "0 0 23 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.5378 0.5L8.13794 7.41284L0.537109 8.52139L5.93558 13.7012L4.66185 21.5L11.5378 17.9114L18.4138 21.5L17.14 13.7012L22.5371 8.52139L14.9363 7.41284L11.5378 0.5Z",
    fill: "#1700F4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarBlueFilled);
export default __webpack_public_path__ + "static/media/star-blue-filled.8f51f440ca48a56ae9418c0ec3fa3447.svg";
export { ForwardRef as ReactComponent };